
import React, { useState, useEffect } from 'react';
import { supabase, isSupabaseConfigured } from '../../lib/supabase';
import { UserProfile, UserRole, Project } from '../../types';
import { Search, ChevronDown, ChevronLeft, ChevronRight } from 'lucide-react';

const AdminUsers: React.FC = () => {
  const [users, setUsers] = useState<UserProfile[]>([]);
  const [projects, setProjects] = useState<Project[]>([]);
  const [userSearchTerm, setUserSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [openProjectDropdown, setOpenProjectDropdown] = useState<string | null>(null);

  useEffect(() => {
    if (isSupabaseConfigured()) {
        supabase.from('profiles').select('*').order('created_at', { ascending: false }).then(({data}) => data && setUsers(data as UserProfile[]));
        supabase.from('projects').select('*').order('name').then(({data}) => data && setProjects(data as Project[]));
    }
    setLoading(false);
  }, []);

  const filteredUsers = users.filter(u => (u.full_name?.toLowerCase() || '').includes(userSearchTerm.toLowerCase()) || (u.email?.toLowerCase() || '').includes(userSearchTerm.toLowerCase()));
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const currentUsers = filteredUsers.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <div className="flex flex-col h-full overflow-hidden">
        {/* BARRE DE FILTRES FIXE (INTERNE) */}
        <div className="p-4 bg-white border-b border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-4 shrink-0">
            <div className="relative flex-1 max-w-md w-full">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
                <input type="text" value={userSearchTerm} onChange={(e) => { setUserSearchTerm(e.target.value); setCurrentPage(1); }} placeholder="Rechercher..." className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg text-sm outline-none focus:ring-2 focus:ring-indigo-500" />
            </div>
            <div className="flex items-center gap-2">
                <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} className="p-1.5 rounded hover:bg-slate-100 disabled:opacity-50"><ChevronLeft size={20}/></button>
                <span className="text-sm font-medium">{currentPage} / {totalPages || 1}</span>
                <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} className="p-1.5 rounded hover:bg-slate-100 disabled:opacity-50"><ChevronRight size={20}/></button>
            </div>
        </div>

        {/* TABLEAU SCROLLABLE */}
        <div className="flex-1 overflow-auto relative bg-white">
            <table className="w-full text-left text-sm text-slate-600 border-collapse">
                <thead className="sticky top-0 z-10 bg-slate-100 text-slate-900 font-bold border-b-2 border-slate-200 shadow-sm">
                    <tr>
                        <th className="px-6 py-4 uppercase tracking-wider text-[11px]">Utilisateur</th>
                        <th className="px-6 py-4 uppercase tracking-wider text-[11px]">Email</th>
                        <th className="px-6 py-4 uppercase tracking-wider text-[11px]">Rôle</th>
                        <th className="px-6 py-4 uppercase tracking-wider text-[11px]">Projets</th>
                        <th className="px-6 py-4 uppercase tracking-wider text-[11px]">Action</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                    {currentUsers.map(user => (
                        <tr key={user.id} className="hover:bg-slate-50">
                            <td className="px-6 py-4 font-medium text-slate-900">{user.full_name}</td>
                            <td className="px-6 py-4">{user.email}</td>
                            <td className="px-6 py-4"><span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-[10px] font-bold uppercase">{user.role}</span></td>
                            <td className="px-6 py-4 text-xs text-slate-400">{(user.project_ids || []).length} assignés</td>
                            <td className="px-6 py-4"><select className="p-1 border rounded text-xs"><option>Modifier Rôle</option></select></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
  );
};

export default AdminUsers;
